import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { VAutocompleteComponent } from "@app/directives/_forms/v-autocomplete/v-autocomplete.component";
import { IPill } from "@app/directives/_veri/v-pills/v-pills.component";
import { IUser } from "@app/interfaces/IUser";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { EngineerService } from "../../../_services/engineer.service";
import './engineer-select.component.scss';

@Component({
    selector: "engineer-select",
    template: require("./engineer-select.component.html")
})
export class EngineerSelectComponent implements OnInit, OnChanges, OnDestroy {
    @Input() selectedEngineers: IUser[] = [];
    @Input() disabled: boolean;
    @Input() resellerId: number;
    @Input() titleKey: string = 'EngineerJobs.AssignEngineer';
    @Output() selectionChanged = new EventEmitter<IUser[]>();

    allEngineers: IUser[];
    availableEngineers: IUser[];
    loading: boolean = true;
    engineerPills: IPill<IUser>[] = [];

    @ViewChild('engineerAutocomplete') dropdown: VAutocompleteComponent<IUser>;

    private destroy$ = new Subject<void>();
    constructor(
        private readonly engineerService: EngineerService) { }

    ngOnInit(): void {
        this.load();
    }

    ngOnChanges(): void {
        this.renderPills();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.unsubscribe();
    }

    onEngineerClicked(engineer: IUser): void {
        if (this.disabled) {
            return;
        }
        this.dropdown?.clearInput();

        this.addPill(engineer);

        this.selectedEngineers = this.engineerPills.map(pill => {
            return pill.data;
        });

        const engineerIndex = this.availableEngineers.findIndex(eng => eng.Id == engineer.Id);

        this.availableEngineers.splice(engineerIndex, 1);

        this.selectionChanged.emit(this.selectedEngineers);
    }

    onEngineerRemoved(pill: IPill<IUser>): void {
        if (this.disabled) {
            return;
        }
        const engineer = pill.data;
        const selectedEngineerIndex = this.selectedEngineers.findIndex(eng => eng.Id === engineer.Id);

        if (selectedEngineerIndex < 0) {
            this.renderPills();
            return;
        }

        this.availableEngineers.push(engineer);

        this.selectedEngineers.splice(selectedEngineerIndex, 1);
        this.renderPills();
        this.selectionChanged.emit(this.selectedEngineers);
    }

    engineerSearchPredicate(engineer: IUser, text: string): boolean {
        return engineer.Description?.toLowerCase().includes(text.toLowerCase());
    }

    //--

    private load(): void {
        this.renderPills();
        this.loadEngineers();
    }

    private loadEngineers(): void {
        this.loading = true;
        this.engineerService.getEngineers().pipe(takeUntil(this.destroy$)).subscribe(engineers => {
            const filteredEngineers = !!this.resellerId ?
                engineers.filter(engineer => engineer.ResellerIds.some(r => r === this.resellerId)) :
                engineers.filter(engineer => !engineer.ResellerIds?.any());

            this.allEngineers = filteredEngineers;

            this.availableEngineers = this.allEngineers.filter(engineer => {
                return engineer.IsActive && !this.selectedEngineers.find(eng => eng.Id == engineer.Id);
            });

            this.loading = false;
        })
    }

    private renderPills(): void {
        this.engineerPills = [];
        if (!this.selectedEngineers) {
            return;
        }

        this.selectedEngineers.forEach(engineer => {
            this.addPill(engineer);
        })
    }

    private addPill(engineer: IUser): void {
        if (!!this.engineerPills.find(pill => pill.data.Id === engineer.Id)) {
            return;
        }
        this.engineerPills.push({
            data: engineer,
            label: engineer.Description,
            icon: 'close'
        })
    }
}
